<div class="grid">
  <div
    style="position: absolute; top: 0; left: 0; width: 100%; background-color: rgba(244,244,244,0.8); z-index: -1"></div>

  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-mobile title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.models' | transloco}}</p>
            <p>{{'menu.descriptions.models' | transloco}}</p>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div>
              <button
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
            </div>
            <div>
              <button (click)="filtersVisible = !filtersVisible" class="p-button-secondary" icon="pi pi-sliders-h"
                      label=" {{'common.filters' | transloco}}"
                      pButton></button>
            </div>
          </div>
        </div>
        <p-dataView #dataView [value]="models" [paginator]="true" [rows]="rows" filterBy="modelName" layout="grid">
          <ng-template let-model pTemplate="gridItem">
            <div class="col-12 md:col-4">
              <div class="card" style="height: 380px;">
                <div>
                  <div class="flex justify-content-end">
                    <button
                      [routerLink]="model.machineModelUuid + '/edit'"
                      pButton
                      pRipple
                      class="p-button-rounded btn-primary-light mr-2"
                      icon="pi pi-pencil"
                    ></button>
                    <button
                      *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_MODEL_DELETION')"
                      pButton
                      pRipple
                      class="p-button-rounded btn-danger-light"
                      (click)="confirmAndDeleteSelected(model.machineModelUuid)"
                      icon="pi pi-trash"
                    ></button>
                  </div>
                </div>
                <div class="text-center">
                  <img [src]="model.image" [alt]="model.name" style="max-height: 200px;"/>
                  <div class="pt-4" style="font-size: 1.5em; font-weight: bold;">{{model.modelName}}</div>
                  <div class="pt-2">{{model.description}}</div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="empty">
          </ng-template>
          <ng-template pTemplate="footer">
            <div *ngIf="totalModels == 0" class="flex align-items-center justify-content-between">{{'pagination.empty' |
              transloco}}</div>
            <div *ngIf="totalModels > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalModels ? totalModels : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalModels}}
              {{(totalModels > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters();" [(ngModel)]="globalFilter"
               [focus]="filtersVisible" appAutoFocus class="w-full" id="name"
               pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <p-button (onClick)="filtersVisible = false; applyFilters()" [disabled]="!globalFilter"
                label="{{'common.filter' | transloco}}"
                styleClass="p-button-primary mx-2 mt-2" type="button"></p-button>
      <p-button (click)="resetFilters(); filtersVisible = false; applyFilters()" label="{{'common.clear' | transloco}}"
                styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>

